import {
  getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile,
  getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** 利用者ID */
  userId: number;
};

type ReturnType = {
  /** 利用者プロフィールデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200;
};

/**
 * useGetPartnerAdminsUserProfile フックの型定義
 */
type IUseGetPartnerAdminsUserProfile = (args: Args) => ReturnType;

/**
 * パートナー管理者向け利用者プロフィール取得フック
 *
 * - GET /api/v1/{three_letter_code}/partner_admins/users/{user_id}/profile
 * - カスタムフィールドの値配列（custom_field_values）を含む
 */
export const useGetPartnerAdminsUserProfile: IUseGetPartnerAdminsUserProfile = ({
  threeLetterCode,
  userId,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfileKey(threeLetterCode, userId),
    () => getApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile(threeLetterCode, userId),
    { suspense: true }
  );

  return {
    data,
  };
};
